import StaticProcessor from '@lib/processors/static-processor'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    type: 'date',
  },
  {
    attribute: 'name',
    label: 'Product Category Name',
    icon: 'el-icon-document',
    type: 'string',
  },
  {
    attribute: 'priority',
    label: 'Priority Ranking',
    icon: 'el-icon-top',
    type: 'numeric',
  },
  {
    attribute: 'updatedAt',
    label: 'Last Updated',
    icon: 'el-icon-date',
    type: 'date',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    format: 'dateTime',
  },
  {
    name: 'name',
    label: 'Product Category Name',
    icon: 'el-icon-document',
  },
  {
    name: 'priority',
    label: 'Priority Ranking',
    icon: 'el-icon-top',
  },
  {
    name: 'updatedAt',
    label: 'Last Updated',
    icon: 'el-icon-date',
    format: 'dateTime',
  },
]

export default function(component) {
  return {
    processor: new StaticProcessor({
      component,
      data: component.categories,
      initialDataQuery: {
        defaultSort: {
          priority: 'asc',
        },
      },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'productCategories',
  }
}
